import React from 'react'
import { Context } from './Context'

/**
 *
 */
export const Provider = ({ company, cSlug, children }) => {
  return <Context.Provider value={{ company }}>{children}</Context.Provider>
}
